import { FC } from "react";
import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { AdminQuizPageContent } from "./AdminQuizPageContent";
import type { QuizDetailDto } from "@/app2/shared/data";

const useStyles = makeStyles()((_theme) => ({
	adminQuizPage: {}
}));

/**
 * Admin Quiz Page (App2)
 *
 * Wrapper for create/edit quiz; uses improve-api (useGetQuiz, useCreateQuiz, useUpdateQuiz, useDeleteQuiz).
 */
export const AdminQuizPage: FC = () => {
	const { quizId } = useParams<{ quizId?: string }>();
	const { classes } = useStyles();
	const navigate = useNavigate();
	const entityId = quizId ? parseInt(quizId, 10) : undefined;

	const handleSaveResponse = (data: QuizDetailDto): void => {
		if (!entityId || data.id !== entityId) {
			navigate(`/admin/quizzes/${data.id}`, { replace: true });
		}
	};

	const handleDeleteResponse = (): void => {
		navigate("/admin/quizzes");
	};

	const handleGetResponse = (data: QuizDetailDto | null, statusCode?: number): void => {
		if (statusCode === 404) {
			navigate("/admin/quizzes");
			return;
		}
		if (data && entityId && data.id !== entityId) {
			navigate(`/admin/quizzes/${data.id}`, { replace: true });
		}
	};

	return (
		<Box className={classes.adminQuizPage}>
			<AdminQuizPageContent
				quizId={entityId}
				onSaveResponse={handleSaveResponse}
				onDeleteResponse={handleDeleteResponse}
				onGetResponse={handleGetResponse}
			/>
		</Box>
	);
};
